import { MousePointerClick, PackageCheck, BellRing } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Stagger, StaggerItem } from "@/components/motion/Reveal";
import { STEPS } from "@/data/content";

const ICONS = { MousePointerClick, PackageCheck, BellRing };

export const HowItWorks = () => (
  <section className="py-20 lg:py-28 bg-white" data-testid="how-it-works-section">
    <div className="container-x">
      <SectionHeading
        align="center"
        eyebrow="How It Works"
        title={<>Protected in three <span className="text-brand-red">simple steps.</span></>}
        sub="No technician, no contracts, no confusion. From order to protected in a matter of days."
      />

      <Stagger className="mt-16 grid gap-8 md:grid-cols-3 relative" gap={0.14}>
        {/* connector line */}
        <div className="hidden md:block absolute top-10 left-[16%] right-[16%] h-px border-t-2 border-dashed border-brand-line" />
        {STEPS.map((s) => {
          const Icon = ICONS[s.icon];
          return (
            <StaggerItem key={s.n} className="relative text-center">
              <div className="relative mx-auto grid place-items-center w-20 h-20 rounded-2xl bg-brand-navy shadow-card">
                <Icon className="w-9 h-9 text-white" strokeWidth={2} />
                <span className="absolute -top-3 -right-3 grid place-items-center w-9 h-9 rounded-full bg-brand-red text-white font-display font-black text-lg border-4 border-white">
                  {s.n}
                </span>
              </div>
              <h3 className="mt-6 font-display font-bold text-2xl text-brand-navy">{s.title}</h3>
              <p className="mt-3 text-brand-ink2 leading-relaxed max-w-sm mx-auto">{s.body}</p>
            </StaggerItem>
          );
        })}
      </Stagger>
    </div>
  </section>
);
